import registry from '../../../../data/sub-processors.json';

export interface SubProcessor {
  id: string;
  name: string;
  type: 'third-party' | 'affiliate';
  services: string;
  category: string;
}

export const META = registry.meta;

export const SUB_PROCESSORS: SubProcessor[] = registry.subProcessors as SubProcessor[];

export const THIRD_PARTY_CATEGORIES: string[] = [
  ...new Set(
    (registry.subProcessors as SubProcessor[])
      .filter(sp => sp.type === 'third-party')
      .map(sp => sp.category)
  )
].sort();
